import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Sidebar from "./../components/sidebar";

const Lecciones = () => {
  const [lecciones, setLecciones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [currentLeccion, setCurrentLeccion] = useState(null);
  const [formData, setFormData] = useState({
    nombreleccion: '',
    descripcion: '',
    urlvideo: '',
    duracion: '',
    idcurso: ''
  });
  const navigate = useNavigate();

  // Función reutilizable para obtener las lecciones
  const fetchLecciones = async () => {
    setLoading(true);
    try {
      const response = await axios.get('https://api.mrcirp.com/public/lecciones');
      setLecciones(response.data);
      setError(null);
    } catch (err) {
      setError(err.message);
      console.error('Error fetching lecciones:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLecciones();
  }, []);

  const handleEditClick = (leccion) => {
    setCurrentLeccion(leccion);
    setFormData({
      nombreleccion: leccion.nombreleccion,
      descripcion: leccion.descripcion,
      urlvideo: leccion.urlvideo,
      duracion: leccion.duracion,
      idcurso: leccion.idcurso
    });
    setShowEditModal(true);
  };

  const handleDeleteClick = (leccion) => {
    setCurrentLeccion(leccion);
    setShowDeleteModal(true);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

 const handleUpdateLeccion = async () => {
  try {
    const response = await axios.put(
      `https://api.mrcirp.com/public/lecciones/${currentLeccion.id}`,
      formData
    );
    
    // Actualización local del estado (sin volver a cargar de la API)
    setLecciones(lecciones.map(leccion => 
      leccion.id === currentLeccion.id ? { ...leccion, ...formData } : leccion
    ));
    console.log(response.data);
    setShowEditModal(false);

  } catch (err) {
    console.error('Error updating lección:', err);
   
  }
};

 const handleDeleteLeccion = async () => {
  try {
    await axios.delete(`https://api.mrcirp.com/public/lecciones/${currentLeccion.id}`);
    
    // Eliminación local del estado (sin volver a cargar de la API)
    setLecciones(lecciones.filter(leccion => leccion.id !== currentLeccion.id));
    
    setShowDeleteModal(false);

  } catch (err) {
    console.error('Error deleting lección:', err);

  }
};

  if (loading) return <div className="text-center my-5">Cargando lecciones...</div>;
  if (error) return <div className="alert alert-danger my-5">Error: {error}</div>;

  return (
    <div>
      <Sidebar>
        <div className="container mt-4">
          <h3 className="mb-4">Lecciones</h3>
          
          <div className="card shadow-sm">
            <div className="card-body">
              <div className="table-responsive">
                <table className="table table-hover">
                  <thead className="table-dark">
                    <tr>
                      <th>Nombre Curso</th>
                      <th>Modulo</th>
                      <th>Nombre Lección</th>
                      <th>Descripción</th>
                      <th>Video</th>
                      <th>Duración</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {lecciones.length > 0 ? (
                      lecciones.map((leccion) => (
                        <tr key={`${leccion.idcurso}-${leccion.nombreleccion}`}>
                          <td>{leccion.nombrecurso}</td>
                          <td>{leccion.nombremodulo}</td>
                          <td>{leccion.nombreleccion}</td>
                          <td>{leccion.descripcion}</td>
                          <td>
                            {leccion.urlvideo ? (
                              <a
                                href={leccion.urlvideo}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-sm btn-outline-primary"
                              >
                                Ver Video
                              </a>
                            ) : (
                              <span className="text-muted">No disponible</span>
                            )}
                          </td>
                          <td>{leccion.duracion} minutos</td>
                        
                          <td>
                            <button
                              className="btn btn-sm btn-outline-info me-2"
                              onClick={() => handleEditClick(leccion)}
                            >
                              Editar
                            </button>
                            <button
                              className="btn btn-sm btn-outline-danger"
                              onClick={() => handleDeleteClick(leccion)}
                            >
                              Eliminar
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7" className="text-center py-4">
                          No hay lecciones disponibles
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </Sidebar>

      {/* Edit Modal */}
      {showEditModal && (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Editar Lección</h5>
                <button type="button" className="btn-close" onClick={() => setShowEditModal(false)}></button>
              </div>
              <div className="modal-body">
                <form>
                  <div className="mb-3">
                    <label className="form-label">Nombre de la Lección</label>
                    <input
                      type="text"
                      className="form-control"
                      name="nombreleccion"
                      value={formData.nombreleccion}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Descripción</label>
                    <textarea
                      className="form-control"
                      name="descripcion"
                      value={formData.descripcion}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">URL del Video</label>
                    <input
                      type="text"
                      className="form-control"
                      name="urlvideo"
                      value={formData.urlvideo}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Duración (minutos)</label>
                    <input
                      type="text"
                      className="form-control"
                      name="duracion"
                      value={formData.duracion}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">ID del Curso</label>
                    <input
                      type="text"
                      className="form-control"
                      name="idcurso"
                      value={formData.idcurso}
                      onChange={handleInputChange}
                      disabled
                    />
                  </div>
                </form>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowEditModal(false)}>
                  Cancelar
                </button>
                <button type="button" className="btn btn-primary" onClick={handleUpdateLeccion}>
                  Guardar Cambios
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {showDeleteModal && (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirmar Eliminación</h5>
                <button type="button" className="btn-close" onClick={() => setShowDeleteModal(false)}></button>
              </div>
              <div className="modal-body">
                <p>¿Estás seguro de que deseas eliminar la lección "{currentLeccion?.nombreleccion}"?</p>
                <p className="text-danger">Esta acción no se puede deshacer.</p>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowDeleteModal(false)}>
                  Cancelar
                </button>
                <button type="button" className="btn btn-danger" onClick={handleDeleteLeccion}>
                  Eliminar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Lecciones;